import React from 'react'
import { Chip } from '@mui/material'
import type { SxProps, Theme } from '@mui/material/styles'
import KeyboardDoubleArrowUp from '@mui/icons-material/KeyboardDoubleArrowUp'
import KeyboardArrowUp from '@mui/icons-material/KeyboardArrowUp'
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown'
import { GREY } from '~/shared/lib/theme'

type PredictedSegment = 'high' | 'medium' | 'low'

interface ComplexityPillProps {
  predictedSegment: PredictedSegment | null | undefined
}

interface SegmentConfig {
  label: string
  backgroundColor: string
  borderColor: string
  iconColor?: string
  icon?: React.ReactElement
}

const SEGMENT_CONFIG: Record<PredictedSegment, SegmentConfig> = {
  high: {
    label: 'High',
    backgroundColor: '#FFE6E5',
    borderColor: '#FF9B99',
    iconColor: '#EB0000',
    icon: <KeyboardDoubleArrowUp />,
  },
  medium: {
    label: 'Medium',
    backgroundColor: '#FFF2EA',
    borderColor: '#FF9954',
    iconColor: '#EB6B15',
    icon: <KeyboardArrowUp />,
  },
  low: {
    label: 'Low',
    backgroundColor: '#FFFFFF',
    borderColor: GREY[500],
    iconColor: '#4D5358',
    icon: <KeyboardArrowDown />,
  },
}

const UNKNOWN_CONFIG: SegmentConfig = {
  label: 'Unknown',
  backgroundColor: GREY[50],
  borderColor: GREY[200],
}

const ComplexityPill: React.FC<ComplexityPillProps> = ({ predictedSegment }) => {
  const config =
    predictedSegment != null ? (SEGMENT_CONFIG[predictedSegment] ?? UNKNOWN_CONFIG) : UNKNOWN_CONFIG

  const sx: SxProps<Theme> = {
    backgroundColor: config.backgroundColor,
    color: GREY[800],
    borderColor: config.borderColor,
    borderWidth: '1.5px',
    fontSize: '13px',
    fontWeight: 400,
    lineHeight: '20px',
    height: '24px',
    borderRadius: '13px',
    '& .MuiChip-label': { px: '8px' },
    '& .MuiChip-icon': {
      color: config.iconColor ?? config.borderColor,
      marginLeft: '6px',
      marginRight: '-4px',
    },
  }

  return <Chip size="small" variant="outlined" label={config.label} icon={config.icon} sx={sx} />
}

export default ComplexityPill
